import Store from '@/store'
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";

export class RedactorUtils {

    static hasMasterAccess() {
        let uid = PermissionsStoreUtils.getMyUserUid();
        let key = PermissionsStoreUtils.REDACTOR_TAB.subpermissions.REDACTOR_FULL_ACCESS.id;
        return PermissionsStoreUtils.getPermission(uid, key);
    }

    static getGlobalConfig() {
        return Store.getters["redactor-store/getGlobalConfig"]();
    }

    static switchGlobalConfig(uid) {
        return Store.dispatch("redactor-store/switchGlobalConfig", uid);
    }

    static getGlobalConfigs() {
        return Store.getters["redactor-store/getGlobalConfigs"]();
    }

    static getConfigUID() {
        return Store.getters["redactor-store/getConfigUID"]();
    }

    static getConfigData(uid) {
        return Store.dispatch("redactor-store/getConfigData", uid);
    }

    //********************************************//
    // redactor-store-product-group
    //********************************************//

    static getProductGroups() {
        return Store.getters["redactor-store-product-group/getValues"]();
    }

    static getProductGroup(uid) {
        let value = Store.getters["redactor-store-product-group/getValue"](uid);
        console.assert(value, "unknown talk id: " + uid);
        return value;
    }

    static pushProductGroup(value) {
        return Store.dispatch("redactor-store-product-group/pushValue", value);
    }

    static removeProductGroup(value) {
        return Store.dispatch("redactor-store-product-group/removeValue", value);
    }

    static removeBulkProductGroups(values) {
        return Store.dispatch("redactor-store-product-group/removeBulkValues", values);
    }

    static convertProductGroup(value) {
        return Store.dispatch("redactor-store-product-group/convertToGlobal", value);
    }

    //********************************************//
    // redactor-store-product-item
    //********************************************//

    static getProducts() {
        return Store.getters["redactor-store-product-item/getValues"]();
    }

    static getProductsByGroup(groups) {

        if (!groups) {
            return this.getProducts();
        } else if (!Array.isArray(groups)) {
            groups = [groups];
        }

        return this.getProducts().filter((value) => {
            let index = groups.findIndex(v => {
                return v.equal(value.group);
            });
            return index >= 0;
        });
    }

    static getProduct(uid) {
        let value = Store.getters["redactor-store-product-item/getValue"](uid);
        console.assert(value, "unknown product id: " + uid);
        return value;
    }

    static pushProduct(value) {
        return Store.dispatch("redactor-store-product-item/pushValue", value);
    }

    static removeProduct(value) {
        return Store.dispatch("redactor-store-product-item/removeValue", value);
    }

    static removeBulkProducts(values) {
        return Store.dispatch("redactor-store-product-item/removeBulkValues", values);
    }

    static convertProduct(value) {
        return Store.dispatch("redactor-store-product-item/convertToGlobal", value);
    }

    //********************************************//
    // redactor-store-talk
    //********************************************//

    static getTalks() {
        return Store.getters["redactor-store-talk/getValues"]();
    }

    static getTalk(uid) {
        let value = Store.getters["redactor-store-talk/getValue"](uid);
        console.assert(value, "unknown talk id: " + uid);
        return value;
    }

    static pushTalk(value) {
        return Store.dispatch("redactor-store-talk/pushValue", value);
    }

    static removeTalk(value) {
        return Store.dispatch("redactor-store-talk/removeValue", value);
    }

    static removeBulkTalks(values) {
        return Store.dispatch("redactor-store-talk/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-level
    //********************************************//

    static getLevels() {
        return Store.getters["redactor-store-level/getValues"]();
    }

    static getLevel(uid) {
        let value = Store.getters["redactor-store-level/getValue"](uid);
        console.assert(value, "unknown level-config id: " + uid);
        return value;
    }

    static pushLevel(value) {
        return Store.dispatch("redactor-store-level/pushValue", value);
    }

    static removeLevel(value) {
        return Store.dispatch("redactor-store-level/removeValue", value);
    }

    static removeBulkLevels(values) {
        return Store.dispatch("redactor-store-level/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-map-kind
    //********************************************//

    static getMapKinds() {
        return Store.getters["redactor-store-map-kind/getValues"]();
    }

    static getMapKindByKey(key) {
        return Store.getters["redactor-store-map-kind/getValueByKey"](key);
    }

    static getMapKind(uid) {
        let value = Store.getters["redactor-store-map-kind/getValue"](uid);
        console.assert(value, "unknown map-kind id: " + uid);
        console.assert(value && value.enabled, "disabled currency-kind id: " + uid);

        return value;
    }

    static getCurrentMapKind() {
        return Store.getters["redactor-store/getMapKind"]();
    }

    static getMapKindByCode(code) {
        const values = Store.getters["redactor-store-map-kind/getValues"]();
        return values.find(m => m.code === code) || null;
    }

    static pushMapKind(value) {
        return Store.dispatch("redactor-store-map-kind/pushValue", value);
    }

    static removeMapKind(value) {
        return Store.dispatch("redactor-store-map-kind/removeValue", value);
    }

    static removeBulkMapKinds(values) {
        return Store.dispatch("redactor-store-map-kind/removeBulkValues", values);
    }

    static exportMapKinds() {
        return Store.dispatch("redactor-store-map-kind/export");
    }

    //********************************************//
    //  redactor-store-map-group
    //********************************************//

    static getMapGroups() {
        return Store.getters["redactor-store-map-group/getValues"]();
    }

    static getMapGroupByKey(key) {
        return Store.getters["redactor-store-map-group/getValueByKey"](key);
    }

    static getMapGroup(uid) {
        let value = Store.getters["redactor-store-map-group/getValue"](uid);
        console.assert(value, "unknown map-group id: " + uid);
        console.assert(value && value.enabled, "disabled map-group id: " + uid);

        return value;
    }

    static pushMapGroup(value) {
        return Store.dispatch("redactor-store-map-group/pushValue", value);
    }

    static removeMapGroup(value) {
        return Store.dispatch("redactor-store-map-group/removeValue", value);
    }

    static removeBulkMapGroups(values) {
        return Store.dispatch("redactor-store-map-group/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-quest
    //********************************************//

    static getQuests() {
        return Store.getters["redactor-store-quest/getValues"]();
    }

    static getQuest(uid) {
        let value = Store.getters["redactor-store-quest/getValue"](uid);
        console.assert(value, "unknown quest uid: " + uid);
        return value;
    }

    static pushQuest(value) {
        return Store.dispatch("redactor-store-quest/pushValue", value);
    }

    static removeQuest(value) {
        return Store.dispatch("redactor-store-quest/removeValue", value);
    }

    static removeBulkQuests(values) {
        return Store.dispatch("redactor-store-quest/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-recipe
    //********************************************//

    static getRecipes() {
        return Store.getters["redactor-store-recipe/getValues"]();
    }

    static getRecipe(uid) {
        let value = Store.getters["redactor-store-recipe/getValue"](uid);
        console.assert(value, "unknown recipe id: " + uid);
        console.assert(value && value.enabled, "disabled recipe id: " + uid);
        return value;
    }

    static pushRecipe(value) {
        return Store.dispatch("redactor-store-recipe/pushValue", value);
    }

    static removeRecipe(value) {
        return Store.dispatch("redactor-store-recipe/removeValue", value);
    }

    static removeBulkRecipes(values) {
        return Store.dispatch("redactor-store-recipe/removeBulkValues", values);
    }


    //********************************************//
    // redactor-store-reward
    //********************************************//

    static getRewardPackages() {
        return Store.getters["redactor-store-reward/getValues"]();
    }

    static getRewardPackage(uid, check_enabled = false) {
        let value = Store.getters["redactor-store-reward/getValue"](uid);
        console.assert(value, "unknown reward id: " + uid);

        if (check_enabled) {
            if (!value) {
                throw new Error("reward_package not found: " + uid);
            } else if (!value.enabled) {
                throw new Error("reward_package disabled: " + uid + " - " + value.name);
            }
        }

        return value;
    }

    static pushRewardPackage(value) {
        return Store.dispatch("redactor-store-reward/pushValue", value);
    }

    static removeRewardPackage(value) {
        return Store.dispatch("redactor-store-reward/removeValue", value);
    }

    static removeBulkRewardPackages(values) {
        return Store.dispatch("redactor-store-reward/removeBulkValues", values);
    }

    static convertRewardPackage(value) {
        return Store.dispatch("redactor-store-reward/convertToGlobal", value);
    }

    //********************************************//
    // redactor-store-currency
    //********************************************//

    static getCurrencyConfigs() {
        return Store.getters["redactor-store-currency/getValues"]();
    }

    static getCurrencyConfig(uid) {
        let value = Store.getters["redactor-store-currency/getValue"](uid);
        console.assert(value, "unknown currency config id: " + uid);
        return value;
    }

    static pushCurrencyConfig(value) {
        return Store.dispatch("redactor-store-currency/pushValue", value);
    }

    static removeCurrencyConfig(value) {
        return Store.dispatch("redactor-store-currency/removeValue", value);
    }

    static removeBulkCurrencyConfigs(values) {
        return Store.dispatch("redactor-store-currency/removeBulkValues", values);
    }

    static convertCurrencyConfig(value) {
        return Store.dispatch("redactor-store-currency/convertToGlobal", value);
    }

    //********************************************//
    //  redactor-store-currency-kind
    //********************************************//

    static getCurrencyKinds() {
        return Store.getters["redactor-store-currency-kind/getValues"]();
    }

    static getCurrencyKindByKey(key) {
        return Store.getters["redactor-store-currency-kind/getValueByKey"](key);
    }

    static getModifierCurrencyKinds() {
        return Store.getters["redactor-store-currency-kind/getModifierValues"]();
    }

    static getMapEnergyCurrencyKinds() {
        return Store.getters["redactor-store-currency-kind/getMapEnergyValues"]();
    }

    static getCurrencyKind(uid) {
        let value = Store.getters["redactor-store-currency-kind/getValue"](uid);
        console.assert(value, "unknown currency-kind id: " + uid);
        console.assert(value && value.enabled, "disabled currency-kind id: " + uid);

        return value;
    }

    static pushCurrencyKind(value) {
        return Store.dispatch("redactor-store-currency-kind/pushValue", value);
    }

    static removeCurrencyKind(value) {
        return Store.dispatch("redactor-store-currency-kind/removeValue", value);
    }

    static removeBulkCurrencyKinds(values) {
        return Store.dispatch("redactor-store-currency-kind/removeBulkValues", values);
    }

    static exportCurrencyKinds() {
        return Store.dispatch("redactor-store-currency-kind/export");
    }

    //********************************************//
    //  redactor-store-currency-group
    //********************************************//

    static getCurrencyGroups() {
        return Store.getters["redactor-store-currency-group/getValues"]();
    }

    static getCurrencyGroupByKey(key) {
        return Store.getters["redactor-store-currency-group/getValueByKey"](key);
    }

    static getCurrencyGroup(uid) {
        let value = Store.getters["redactor-store-currency-group/getValue"](uid);
        console.assert(value, "unknown currency-group id: " + uid);
        console.assert(value && value.enabled, "disabled currency-group id: " + uid);

        return value;
    }

    static pushCurrencyGroup(value) {
        return Store.dispatch("redactor-store-currency-group/pushValue", value);
    }

    static removeCurrencyGroup(value) {
        return Store.dispatch("redactor-store-currency-group/removeValue", value);
    }

    static removeBulkCurrencyGroups(values) {
        return Store.dispatch("redactor-store-currency-group/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-exchange
    //********************************************//

    static getExchangeConfigs() {
        return Store.getters["redactor-store-exchange/getValues"]();
    }

    static getExchangeConfig(uid) {
        let value = Store.getters["redactor-store-exchange/getValue"](uid);
        console.assert(value, "unknown exchange config id: " + uid);
        return value;
    }

    static pushExchangeConfig(value) {
        return Store.dispatch("redactor-store-exchange/pushValue", value);
    }

    static removeExchangeConfig(value) {
        return Store.dispatch("redactor-store-exchange/removeValue", value);
    }

    static removeBulkExchangeConfigs(values) {
        return Store.dispatch("redactor-store-exchange/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-tutorial
    //********************************************//

    static getTutorials() {
        return Store.getters["redactor-store-tutorial/getValues"]();
    }

    static getTutorial(uid) {
        let value = Store.getters["redactor-store-tutorial/getValue"](uid);
        console.assert(value, "unknown tutorial id: " + uid);
        return value;
    }

    static pushTutorial(value) {
        return Store.dispatch("redactor-store-tutorial/pushValue", value);
    }

    static removeTutorial(value) {
        return Store.dispatch("redactor-store-tutorial/removeValue", value);
    }

    static removeBulkTutorials(values) {
        return Store.dispatch("redactor-store-tutorial/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-discovery
    //********************************************//

    static getDiscoveries() {
        return Store.getters["redactor-store-discovery/getValues"]();
    }

    static getDiscovery(uid) {
        let value = Store.getters["redactor-store-discovery/getValue"](uid);
        console.assert(value, "unknown discovery: " + uid);
        return value;
    }

    static pushDiscovery(value) {
        return Store.dispatch("redactor-store-discovery/pushValue", value);
    }

    static removeDiscovery(value) {
        return Store.dispatch("redactor-store-discovery/removeValue", value);
    }

    static removeBulkDiscoverys(values) {
        return Store.dispatch("redactor-store-discovery/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-prompt
    //********************************************//

    static getPrompts() {
        return Store.getters["redactor-store-prompt/getValues"]();
    }

    static getPrompt(uid) {
        let value = Store.getters["redactor-store-prompt/getValue"](uid);
        console.assert(value, "unknown prompt id: " + uid);
        return value;
    }

    static pushPrompt(value) {
        return Store.dispatch("redactor-store-prompt/pushValue", value);
    }

    static removePrompt(value) {
        return Store.dispatch("redactor-store-prompt/removeValue", value);
    }

    static removeBulkPrompts(values) {
        return Store.dispatch("redactor-store-prompt/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-firefly
    //********************************************//

    static getFireflies() {
        return Store.getters["redactor-store-firefly/getValues"]();
    }

    static getFirefly(uid) {
        let value = Store.getters["redactor-store-firefly/getValue"](uid);
        console.assert(value, "unknown firefly id: " + uid);
        return value;
    }

    static pushFirefly(value) {
        return Store.dispatch("redactor-store-firefly/pushValue", value);
    }

    static removeFirefly(value) {
        return Store.dispatch("redactor-store-firefly/removeValue", value);
    }

    static removeBulkFireflys(values) {
        return Store.dispatch("redactor-store-firefly/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-firefly-v2
    //********************************************//
    static getFirefliesV2() {
        return Store.getters["redactor-store-firefly-v2/getValues"]();
    }

    static getFireflyV2(uid) {
        let value = Store.getters["redactor-store-firefly-v2/getValue"](uid);
        console.assert(value, "unknown firefly id: " + uid);
        return value;
    }

    static pushFireflyV2(value) {
        return Store.dispatch("redactor-store-firefly-v2/pushValue", value);
    }

    static removeFireflyV2(value) {
        return Store.dispatch("redactor-store-firefly-v2/removeValue", value);
    }

    static removeBulkFireflyV2s(values) {
        return Store.dispatch("redactor-store-firefly-v2/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-setting
    //********************************************//

    static getSettings() {
        return Store.getters["redactor-store-setting/getValues"]();
    }

    static getSetting(uid) {
        let value = Store.getters["redactor-store-setting/getValue"](uid);
        console.assert(value, "unknown setting id: " + uid);
        return value;
    }

    static pushSetting(value) {
        return Store.dispatch("redactor-store-setting/pushValue", value);
    }

    static removeSetting(value) {
        return Store.dispatch("redactor-store-setting/removeValue", value);
    }

    static removeBulkSettings(values) {
        return Store.dispatch("redactor-store-setting/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-world-region
    //********************************************//

    static getWorldRegions() {
        return Store.getters["redactor-store-world-region/getValues"]();
    }

    static getWorldRegion(uid) {
        let value = Store.getters["redactor-store-world-region/getValue"](uid);
        console.assert(value, "unknown world region id: " + uid);
        return value;
    }

    static pushWorldRegion(value) {
        return Store.dispatch("redactor-store-world-region/pushValue", value);
    }

    static removeWorldRegion(value) {
        return Store.dispatch("redactor-store-world-region/removeValue", value);
    }

    static removeBulkWorldRegions(values) {
        return Store.dispatch("redactor-store-world-region/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-world-region-territory
    //********************************************//

    static getWorldRegionTerritories() {
        return Store.getters["redactor-store-world-region-territory/getValues"]();
    }

    static getWorldRegionTerritory(uid) {
        let value = Store.getters["redactor-store-world-region-territory/getValue"](uid);
        console.assert(value, "unknown world region territory id: " + uid);
        return value;
    }

    static pushWorldRegionTerritory(value) {
        return Store.dispatch("redactor-store-world-region-territory/pushValue", value);
    }

    static removeWorldRegionTerritory(value) {
        return Store.dispatch("redactor-store-world-region-territory/removeValue", value);
    }

    static removeBulkWorldRegionTerritories(values) {
        return Store.dispatch("redactor-store-world-region-territory/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-swamp
    //********************************************//

    static getSwamps() {
        return Store.getters["redactor-store-swamp/getValues"]();
    }

    static getSwamp(uid) {
        let value = Store.getters["redactor-store-swamp/getValue"](uid);
        console.assert(value, "unknown swamp id: " + uid);
        return value;
    }

    static pushSwamp(value) {
        return Store.dispatch("redactor-store-swamp/pushValue", value);
    }

    static removeSwamp(value) {
        return Store.dispatch("redactor-store-swamp/removeValue", value);
    }

    static removeBulkSwamps(values) {
        return Store.dispatch("redactor-store-swamp/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-worker-team
    //********************************************//

    static getWorkerTeams() {
        return Store.getters["redactor-store-worker-team/getValues"]();
    }

    static getWorkerTeam(uid) {
        let value = Store.getters["redactor-store-worker-team/getValue"](uid);
        console.assert(value, "unknown worker team id: " + uid);
        return value;
    }

    static pushWorkerTeam(value) {
        return Store.dispatch("redactor-store-worker-team/pushValue", value);
    }

    static removeWorkerTeam(value) {
        return Store.dispatch("redactor-store-worker-team/removeValue", value);
    }

    static removeBulkWorkerTeams(values) {
        return Store.dispatch("redactor-store-worker-team/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-challenge
    //********************************************//

    static getChallengeConfigs() {
        return Store.getters["redactor-store-challenge/getValues"]();
    }

    static getChallengeConfig(uid) {
        let value = Store.getters["redactor-store-challenge/getValue"](uid);
        console.assert(value, "unknown challenge id: " + uid);
        return value;
    }

    static pushChallengeConfig(value) {
        return Store.dispatch("redactor-store-challenge/pushValue", value);
    }

    static removeChallengeConfig(value) {
        return Store.dispatch("redactor-store-challenge/removeValue", value);
    }

    static removeBulkChallengeConfigs(values) {
        return Store.dispatch("redactor-store-challenge/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-smart-offer
    //********************************************//

    static getSmartOffers() {
        return Store.getters["redactor-store-smart-offer/getValues"]();
    }

    static getSmartOffer(uid) {
        let value = Store.getters["redactor-store-smart-offer/getValue"](uid);
        console.assert(value, "unknown smart-offer uid: " + uid);
        return value;
    }

    static pushSmartOffer(value) {
        return Store.dispatch("redactor-store-smart-offer/pushValue", value);
    }

    static removeSmartOffer(value) {
        return Store.dispatch("redactor-store-smart-offer/removeValue", value);
    }

    static removeBulkSmartOffers(values) {
        return Store.dispatch("redactor-store-smart-offer/removeBulkValues", values);
    }

    static convertSmartOffer(value) {
        return Store.dispatch("redactor-store-smart-offer/convertToGlobal", value);
    }

    //********************************************//
    // redactor-store-item
    //********************************************//

    static getItems() {
        return Store.getters["redactor-store-item/getValues"]();
    }

    static getItem(uid) {
        let value = Store.getters["redactor-store-item/getValue"](uid);
        console.assert(value, "unknown item id: " + uid);
        console.assert(value && value.enabled, "disabled item id: " + uid);
        return value;
    }

    static pushItem(value) {
        return Store.dispatch("redactor-store-item/pushValue", value);
    }

    static removeItem(value) {
        return Store.dispatch("redactor-store-item/removeValue", value);
    }

    static removeBulkItems(values) {
        return Store.dispatch("redactor-store-item/removeBulkValues", values);
    }

    static convertItem(value) {
        return Store.dispatch("redactor-store-item/convertToGlobal", value);
    }

    //********************************************//
    //  redactor-store-item-kind
    //********************************************//

    static getItemKinds() {
        return Store.getters["redactor-store-item-kind/getValues"]();
    }

    static getItemKindByKey(key) {
        return Store.getters["redactor-store-item-kind/getValueByKey"](key);
    }

    static getItemKind(uid) {
        let value = Store.getters["redactor-store-item-kind/getValue"](uid);
        console.assert(value, "unknown item-kind id: " + uid);
        console.assert(value && value.enabled, "disabled item-kind id: " + uid);

        return value;
    }

    static pushItemKind(value) {
        return Store.dispatch("redactor-store-item-kind/pushValue", value);
    }

    static removeItemKind(value) {
        return Store.dispatch("redactor-store-item-kind/removeValue", value);
    }

    static removeBulkItemKinds(values) {
        return Store.dispatch("redactor-store-item-kind/removeBulkValues", values);
    }

    static exportItemKinds() {
        return Store.dispatch("redactor-store-item-kind/export");
    }

    //  redactor-store-worker-kind
    //********************************************//

    static getWorkerKinds() {
        return Store.getters["redactor-store-worker-kind/getValues"]();
    }

    static getWorkerKindByKey(key) {
        console.log("getWorkerKindByKey", key);
        return Store.getters["redactor-store-worker-kind/getValueByKey"](key);
    }

    static getWorkerKind(uid) {
        let value = Store.getters["redactor-store-worker-kind/getValue"](uid);
        console.assert(value, "unknown worker-kind id: " + uid);
        console.assert(value && value.enabled, "disabled worker-kind id: " + uid);

        return value;
    }

    static pushWorkerKind(value) {
        console.log(value);
        return Store.dispatch("redactor-store-worker-kind/pushValue", value);
    }

    static removeWorkerKind(value) {
        return Store.dispatch("redactor-store-worker-kind/removeValue", value);
    }

    static removeBulkWorkerKinds(values) {
        return Store.dispatch("redactor-store-worker-kind/removeBulkValues", values);
    }

    static exportWorkerKinds() {
        return Store.dispatch("redactor-store-worker-kind/export");
    }

    //********************************************//
    //  redactor-store-item-group
    //********************************************//

    static getItemGroups() {
        return Store.getters["redactor-store-item-group/getValues"]();
    }

    static getItemGroupByKey(key) {
        return Store.getters["redactor-store-item-group/getValueByKey"](key);
    }

    static getItemGroup(uid) {
        let value = Store.getters["redactor-store-item-group/getValue"](uid);
        console.assert(value, "unknown item-group id: " + uid);
        console.assert(value && value.enabled, "disabled item-group id: " + uid);

        return value;
    }

    static pushItemGroup(value) {
        return Store.dispatch("redactor-store-item-group/pushValue", value);
    }

    static removeItemGroup(value) {
        return Store.dispatch("redactor-store-item-group/removeValue", value);
    }

    static removeBulkItemGroups(values) {
        return Store.dispatch("redactor-store-item-group/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-item-addon
    //********************************************//

    static getItemAddons() {
        return Store.getters["redactor-store-item-addon/getValues"]();
    }

    static getItemAddon(uid) {
        let value = Store.getters["redactor-store-item-addon/getValue"](uid);
        console.assert(value, "unknown item-addon id: " + uid);
        console.assert(value && value.enabled, "disabled item-addon id: " + uid);
        return value;
    }

    static pushItemAddon(value) {
        return Store.dispatch("redactor-store-item-addon/pushValue", value);
    }

    static removeItemAddon(value) {
        return Store.dispatch("redactor-store-item-addon/removeValue", value);
    }

    static removeBulkItemAddons(values) {
        return Store.dispatch("redactor-store-item-addon/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-item-offer
    //********************************************//
    static getItemOffers() {
        return Store.getters["redactor-store-item-offer/getValues"]();
    }

    static getItemOffer(uid) {
        let value = Store.getters["redactor-store-item-offer/getValue"](uid);
        console.assert(value, "unknown item-offer id: " + uid);
        console.assert(value && value.enabled, "disabled item-offer id: " + uid);
        return value;
    }

    static pushItemOffer(value) {
        return Store.dispatch("redactor-store-item-offer/pushValue", value);
    }

    static removeItemOffer(value) {
        return Store.dispatch("redactor-store-item-offer/removeValue", value);
    }

    static removeBulkItemOffers(values) {
        return Store.dispatch("redactor-store-item-offer/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-item-order
    //********************************************//

    static getItemOrders() {
        return Store.getters["redactor-store-item-order/getValues"]();
    }

    static getItemOrder(uid) {
        let value = Store.getters["redactor-store-item-order/getValue"](uid);
        console.assert(value, "unknown item-order id: " + uid);
        console.assert(value && value.enabled, "disabled item-order id: " + uid);

        return value;
    }

    static pushItemOrder(value) {
        return Store.dispatch("redactor-store-item-order/pushValue", value);
    }

    static removeItemOrder(value) {
        return Store.dispatch("redactor-store-item-order/removeValue", value);
    }

    static removeBulkItemOrders(values) {
        return Store.dispatch("redactor-store-item-order/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-item-shop
    //********************************************//

    static getItemShops() {
        return Store.getters["redactor-store-item-shop/getValues"]();
    }

    static getItemShop(uid) {
        let value = Store.getters["redactor-store-item-shop/getValue"](uid);
        console.assert(value, "unknown item-shop id: " + uid);
        console.assert(value && value.enabled, "disabled item-shop id: " + uid);
        return value;
    }

    static pushItemShop(value) {
        return Store.dispatch("redactor-store-item-shop/pushValue", value);
    }

    static removeItemShop(value) {
        return Store.dispatch("redactor-store-item-shop/removeValue", value);
    }

    static removeBulkItemShops(values) {
        return Store.dispatch("redactor-store-item-shop/removeBulkValues", values);
    }


    //********************************************//
    //  redactor-store-item-recipe
    //********************************************//

    static getItemRecipes() {
        return Store.getters["redactor-store-item-recipe/getValues"]();
    }

    static getItemRecipe(uid) {
        let value = Store.getters["redactor-store-item-recipe/getValue"](uid);
        console.assert(value, "unknown item-recipe id: " + uid);
        console.assert(value && value.enabled, "disabled item-recipe id: " + uid);

        return value;
    }

    static pushItemRecipe(value) {
        return Store.dispatch("redactor-store-item-recipe/pushValue", value);
    }

    static removeItemRecipe(value) {
        return Store.dispatch("redactor-store-item-recipe/removeValue", value);
    }

    static removeBulkItemRecipes(values) {
        return Store.dispatch("redactor-store-item-recipe/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-item-cluster
    //********************************************//

    static getItemClusters() {
        return Store.getters["redactor-store-item-cluster/getValues"]();
    }

    static getItemCluster(uid) {
        let value = Store.getters["redactor-store-item-cluster/getValue"](uid);
        console.assert(value, "unknown item-cluster: " + uid);
        return value;
    }

    static pushItemCluster(value) {
        return Store.dispatch("redactor-store-item-cluster/pushValue", value);
    }

    static removeItemCluster(value) {
        return Store.dispatch("redactor-store-item-cluster/removeValue", value);
    }

    static removeBulkItemClusters(values) {
        return Store.dispatch("redactor-store-item-cluster/removeBulkValues", values);
    }

    static convertItemCluster(value) {
        return Store.dispatch("redactor-store-item-cluster/convertToGlobal", value);
    }

    //********************************************//
    //  redactor-store-item-social
    //********************************************//

    static getItemsSocial() {
        return Store.getters["redactor-store-item-social/getValues"]();
    }

    static getItemSocial(uid) {
        let value = Store.getters["redactor-store-item-social/getValue"](uid);
        console.assert(value, "unknown item-social: " + uid);
        return value;
    }

    static pushItemSocial(value) {
        return Store.dispatch("redactor-store-item-social/pushValue", value);
    }

    static removeItemSocial(value) {
        return Store.dispatch("redactor-store-item-social/removeValue", value);
    }

    static removeBulkItemSocials(values) {
        return Store.dispatch("redactor-store-item-social/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-trader-order
    //********************************************//

    static getTraderOrders() {
        return Store.getters["redactor-store-trader-order/getValues"]();
    }

    static pushTraderOrders(values) {
        return Store.dispatch("redactor-store-trader-order/pushValues", values);
    }

    static getTraderOrder(uid) {
        let value = Store.getters["redactor-store-trader-order/getValue"](uid);
        console.assert(value, "unknown order uid: " + uid);
        return value;
    }

    static pushTraderOrder(value) {
        return Store.dispatch("redactor-store-trader-order/pushValue", value);
    }

    static removeTraderOrder(value) {
        return Store.dispatch("redactor-store-trader-order/removeValue", value);
    }

    static removeBulkTraderOrders(values) {
        return Store.dispatch("redactor-store-trader-order/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-trader-offer
    //********************************************//

    static getTraderOffers() {
        return Store.getters["redactor-store-trader-offer/getValues"]();
    }

    static pushTraderOffers(values) {
        return Store.dispatch("redactor-store-trader-offer/pushValues", values);
    }

    static getTraderOffer(uid) {
        let value = Store.getters["redactor-store-trader-offer/getValue"](uid);
        console.assert(value, "unknown offer uid: " + uid);
        return value;
    }

    static pushTraderOffer(value) {
        return Store.dispatch("redactor-store-trader-offer/pushValue", value);
    }

    static removeTraderOffer(value) {
        return Store.dispatch("redactor-store-trader-offer/removeValue", value);
    }

    static removeBulkTraderOffers(values) {
        return Store.dispatch("redactor-store-trader-offer/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-trader-config
    //********************************************//

    static getTraderConfigs() {
        return Store.getters["redactor-store-trader-config/getValues"]();
    }

    static getTraderConfig(uid) {
        let value = Store.getters["redactor-store-trader-config/getValue"](uid);
        console.assert(value, "unknown config uid: " + uid);
        return value;
    }

    static pushTraderConfig(value) {
        return Store.dispatch("redactor-store-trader-config/pushValue", value);
    }

    static removeTraderConfig(value) {
        return Store.dispatch("redactor-store-trader-config/removeValue", value);
    }

    static removeBulkTraderConfigs(values) {
        return Store.dispatch("redactor-store-trader-config/removeBulkValues", values);
    }


    //********************************************//
    //  redactor-store-daily-bonus-track
    //********************************************//

    static getDailyBonusTracks() {
        return Store.getters["redactor-store-daily-bonus-track/getValues"]();
    }

    static getDailyBonusTrack(uid) {
        let value = Store.getters["redactor-store-daily-bonus-track/getValue"](uid);
        console.assert(value, "unknown daily-bonus-track uid: " + uid);
        return value;
    }

    static pushDailyBonusTrack(value) {
        return Store.dispatch("redactor-store-daily-bonus-track/pushValue", value);
    }

    static removeDailyBonusTrack(value) {
        return Store.dispatch("redactor-store-daily-bonus-track/removeValue", value);
    }

    static removeBulkDailyBonusTracks(values) {
        return Store.dispatch("redactor-store-daily-bonus-track/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-daily-bonus-config
    //********************************************//

    static getDailyBonusConfigs() {
        return Store.getters["redactor-store-daily-bonus-config/getValues"]();
    }

    static getDailyBonusConfig(uid) {
        let value = Store.getters["redactor-store-daily-bonus-config/getValue"](uid);
        console.assert(value, "unknown daily-bonus-config uid: " + uid);
        return value;
    }

    static pushDailyBonusConfig(value) {
        return Store.dispatch("redactor-store-daily-bonus-config/pushValue", value);
    }

    static removeDailyBonusConfig(value) {
        return Store.dispatch("redactor-store-daily-bonus-config/removeValue", value);
    }

    static removeBulkDailyBonusConfigs(values) {
        return Store.dispatch("redactor-store-daily-bonus-config/removeBulkValues", values);
    }


    //********************************************//
    //  redactor-store-daily-quest-order
    //********************************************//

    static getDailyQuestOrders() {
        return Store.getters["redactor-store-daily-quest-order/getValues"]();
    }

    static getDailyQuestOrder(uid) {
        let value = Store.getters["redactor-store-daily-quest-order/getValue"](uid);
        console.assert(value, "unknown daily-quest-order uid: " + uid);
        return value;
    }

    static pushDailyQuestOrder(value) {
        return Store.dispatch("redactor-store-daily-quest-order/pushValue", value);
    }

    static removeDailyQuestOrder(value) {
        return Store.dispatch("redactor-store-daily-quest-order/removeValue", value);
    }

    static removeBulkDailyQuestOrders(values) {
        return Store.dispatch("redactor-store-daily-quest-order/removeBulkValues", values);
    }


    //********************************************//
    //  redactor-store-daily-quest-config
    //********************************************//

    static getDailyQuestConfigs() {
        return Store.getters["redactor-store-daily-quest-config/getValues"]();
    }

    static getDailyQuestConfig(uid) {
        let value = Store.getters["redactor-store-daily-quest-config/getValue"](uid);
        console.assert(value, "unknown daily-quest-config uid: " + uid);
        return value;
    }

    static pushDailyQuestConfig(value) {
        return Store.dispatch("redactor-store-daily-quest-config/pushValue", value);
    }

    static removeDailyQuestConfig(value) {
        return Store.dispatch("redactor-store-daily-quest-config/removeValue", value);
    }

    static removeBulkDailyQuestConfigs(values) {
        return Store.dispatch("redactor-store-daily-quest-config/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-boat-order
    //********************************************//

    static getBoatOrders() {
        return Store.getters["redactor-store-boat-order/getValues"]();
    }

    static getBoatOrder(uid) {
        let value = Store.getters["redactor-store-boat-order/getValue"](uid);
        console.assert(value, "unknown boat-order uid: " + uid);
        return value;
    }

    static pushBoatOrder(value) {
        return Store.dispatch("redactor-store-boat-order/pushValue", value);
    }

    static removeBoatOrder(value) {
        return Store.dispatch("redactor-store-boat-order/removeValue", value);
    }

    static removeBulkBoatOrders(values) {
        return Store.dispatch("redactor-store-boat-order/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-boat-config
    //********************************************//

    static getBoatConfigs() {
        return Store.getters["redactor-store-boat-config/getValues"]();
    }

    static getBoatConfig(uid) {
        let value = Store.getters["redactor-store-boat-config/getValue"](uid);
        console.assert(value, "unknown boat-config uid: " + uid);
        return value;
    }

    static pushBoatConfig(value) {
        return Store.dispatch("redactor-store-boat-config/pushValue", value);
    }

    static removeBoatConfig(value) {
        return Store.dispatch("redactor-store-boat-config/removeValue", value);
    }

    static removeBulkBoatConfigs(values) {
        return Store.dispatch("redactor-store-boat-config/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-sky-sprint-config
    //********************************************//

    static getSkySprintConfigs() {
        return Store.getters["redactor-store-sky-sprint-config/getValues"]();
    }

    static getSkySprintConfig(uid) {
        let value = Store.getters["redactor-store-sky-sprint-config/getValue"](uid);
        console.assert(value, "unknown sky-sprint-config id: " + uid);
        return value;
    }

    static pushSkySprintConfig(value) {
        return Store.dispatch("redactor-store-sky-sprint-config/pushValue", value);
    }

    static removeSkySprintConfig(value) {
        return Store.dispatch("redactor-store-sky-sprint-config/removeValue", value);
    }

    static removeBulkSkySprintConfigs(values) {
        return Store.dispatch("redactor-store-sky-sprint-config/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-sky-common-config
    //********************************************//

    static getSkyCommonConfigs() {
        return Store.getters["redactor-store-sky-common-config/getValues"]();
    }

    static getSkyCommonConfig(uid) {
        let value = Store.getters["redactor-store-sky-common-config/getValue"](uid);
        console.assert(value, "unknown sky-common-config id: " + uid);
        return value;
    }

    static pushSkyCommonConfig(value) {
        return Store.dispatch("redactor-store-sky-common-config/pushValue", value);
    }

    static removeSkyCommonConfig(value) {
        return Store.dispatch("redactor-store-sky-common-config/removeValue", value);
    }

    static removeBulkSkyCommonConfigs(values) {
        return Store.dispatch("redactor-store-sky-common-config/removeBulkValues", values);
    }


    //********************************************//
    //  redactor-store-league-config
    //********************************************//

    static getLeagueConfigs() {
        return Store.getters["redactor-store-league-config/getValues"]();
    }

    static getLeagueConfig(uid) {
        let value = Store.getters["redactor-store-league-config/getValue"](uid);
        console.assert(value, "unknown league-config id: " + uid);
        return value;
    }

    static pushLeagueConfig(value) {
        return Store.dispatch("redactor-store-league-config/pushValue", value);
    }

    static removeLeagueConfig(value) {
        return Store.dispatch("redactor-store-league-config/removeValue", value);
    }

    static removeBulkLeagueConfigs(values) {
        return Store.dispatch("redactor-store-league-config/removeBulkValues", values);
    }

    //********************************************//
    // redactor-store-ad-energy-refill
    //********************************************//

    static getAdRefills() {
        return Store.getters["redactor-store-ad-energy-refill/getValues"]();
    }

    static getAdRefill(uid) {
        let value = Store.getters["redactor-store-ad-energy-refill/getValue"](uid);
        console.assert(value, "unknown ad-energy-refill id: " + uid);
        return value;
    }

    static pushAdRefill(value) {
        return Store.dispatch("redactor-store-ad-energy-refill/pushValue", value);
    }

    static removeAdRefill(value) {
        return Store.dispatch("redactor-store-ad-energy-refill/removeValue", value);
    }

    static removeBulkAdRefills(values) {
        return Store.dispatch("redactor-store-ad-energy-refill/removeBulkValues", values);
    }


    //********************************************//
    //  redactor-store-avatar
    //********************************************//

    static getAvatars() {
        return Store.getters["redactor-store-avatar/getValues"]();
    }

    static getAvatar(uid) {
        let value = Store.getters["redactor-store-avatar/getValue"](uid);
        console.assert(value, "unknown avatar id: " + uid);
        console.assert(value && value.enabled, "disabled avatar id: " + uid);

        return value;
    }

    static pushAvatar(value) {
        return Store.dispatch("redactor-store-avatar/pushValue", value);
    }

    static removeAvatar(value) {
        return Store.dispatch("redactor-store-avatar/removeValue", value);
    }

    static removeBulkAvatars(values) {
        return Store.dispatch("redactor-store-avatar/removeBulkValues", values);
    }

    static convertAvatar(value) {
        return Store.dispatch("redactor-store-avatar/convertToGlobal", value);
    }

    //********************************************//
    //  redactor-store-booster
    //********************************************//

    static getBoosters() {
        return Store.getters["redactor-store-booster/getValues"]();
    }

    static getBooster(uid) {
        let value = Store.getters["redactor-store-booster/getValue"](uid);
        console.assert(value, "unknown booster id: " + uid);
        console.assert(value && value.enabled, "disabled booster id: " + uid);

        return value;
    }

    static pushBooster(value) {
        return Store.dispatch("redactor-store-booster/pushValue", value);
    }

    static removeBooster(value) {
        return Store.dispatch("redactor-store-booster/removeValue", value);
    }

    static removeBulkBoosters(values) {
        return Store.dispatch("redactor-store-booster/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-card
    //********************************************//

    static getCards() {
        return Store.getters["redactor-store-card/getValues"]();
    }

    static getCard(uid) {
        let value = Store.getters["redactor-store-card/getValue"](uid);
        console.assert(value, "unknown card id: " + uid);
        //console.assert(value && value.enabled, "disabled card id: " + uid);

        return value;
    }

    static pushCard(value) {
        return Store.dispatch("redactor-store-card/pushValue", value);
    }

    static removeCard(value) {
        return Store.dispatch("redactor-store-card/removeValue", value);
    }

    static removeBulkCards(values) {
        return Store.dispatch("redactor-store-card/removeBulkValues", values);
    }


    //********************************************//
    //  redactor-store-item-cluster
    //********************************************//

    static getCardClusters() {
        return Store.getters["redactor-store-card-cluster/getValues"]();
    }

    static getCardCluster(uid) {
        let value = Store.getters["redactor-store-card-cluster/getValue"](uid);
        console.assert(value, "unknown card-cluster: " + uid);
        return value;
    }

    static pushCardCluster(value) {
        return Store.dispatch("redactor-store-card-cluster/pushValue", value);
    }

    static removeCardCluster(value) {
        return Store.dispatch("redactor-store-card-cluster/removeValue", value);
    }

    static removeBulkCardClusters(values) {
        return Store.dispatch("redactor-store-card-cluster/removeBulkValues", values);
    }


    //********************************************//
    //  redactor-store-card-package
    //********************************************//

    static getCardPackages() {
        return Store.getters["redactor-store-card-package/getValues"]();
    }

    static getCardPackage(uid) {
        let value = Store.getters["redactor-store-card-package/getValue"](uid);
        console.assert(value, "unknown card-package id: " + uid);
        console.assert(value && value.enabled, "disabled card-package id: " + uid);

        return value;
    }

    static pushCardPackage(value) {
        return Store.dispatch("redactor-store-card-package/pushValue", value);
    }

    static removeCardPackage(value) {
        return Store.dispatch("redactor-store-card-package/removeValue", value);
    }

    static removeBulkCardPackages(values) {
        return Store.dispatch("redactor-store-card-package/removeBulkValues", values);
    }


    //********************************************//
    //  redactor-store-ad-placement
    //********************************************//

    static getAdPlacements() {
        return Store.getters["redactor-store-ad-placement/getValues"]();
    }

    static getAdPlacement(uid) {
        let value = Store.getters["redactor-store-ad-placement/getValue"](uid);
        console.assert(value, "unknown ad-placement id: " + uid);
        console.assert(value && value.enabled, "disabled ad-placement id: " + uid);
        return value;
    }

    static pushAdPlacement(value) {
        return Store.dispatch("redactor-store-ad-placement/pushValue", value);
    }

    static removeAdPlacement(value) {
        return Store.dispatch("redactor-store-ad-placement/removeValue", value);
    }

    static removeBulkAdPlacements(values) {
        return Store.dispatch("redactor-store-ad-placement/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-ad-unit
    //********************************************//

    static getAdUnits() {
        return Store.getters["redactor-store-ad-unit/getValues"]();
    }

    static getAdUnit(uid) {
        let value = Store.getters["redactor-store-ad-unit/getValue"](uid);
        console.assert(value, "unknown ad-unit id: " + uid);
        console.assert(value && value.enabled, "disabled ad-unit id: " + uid);
        return value;
    }

    static pushAdUnit(value) {
        return Store.dispatch("redactor-store-ad-unit/pushValue", value);
    }

    static removeAdUnit(value) {
        return Store.dispatch("redactor-store-ad-unit/removeValue", value);
    }

    static removeBulkAdUnits(values) {
        return Store.dispatch("redactor-store-ad-unit/removeBulkValues", values);
    }

    //********************************************//
    //  redactor-store-map-addon
    //********************************************//

    static getMapAddons() {
        return Store.getters["redactor-store-map-addon/getValues"]();
    }

    static getMapAddon(uid) {
        let value = Store.getters["redactor-store-map-addon/getValue"](uid);
        console.assert(value, "unknown map-addon id: " + uid);
        console.assert(value && value.enabled, "disabled map-addon id: " + uid);
        return value;
    }

    static pushMapAddon(value) {
        return Store.dispatch("redactor-store-map-addon/pushValue", value);
    }

    static removeMapAddon(value) {
        return Store.dispatch("redactor-store-map-addon/removeValue", value);
    }

    static removeBulkMapAddons(values) {
        return Store.dispatch("redactor-store-map-addon/removeBulkValues", values);
    }

    static convertMapAddon(value) {
        return Store.dispatch("redactor-store-map-addon/convertToGlobal", value);
    }

    //********************************************//
    //  redactor-store-map-addon-group
    //********************************************//

    static getMapAddonGroups() {
        return Store.getters["redactor-store-map-addon-group/getValues"]();
    }

    static getMapAddonGroup(uid) {
        let value = Store.getters["redactor-store-map-addon-group/getValue"](uid);
        console.assert(value, "unknown map-addon-group id: " + uid);
        console.assert(value && value.enabled, "disabled map-addon-group id: " + uid);
        return value;
    }

    static pushMapAddonGroup(value) {
        return Store.dispatch("redactor-store-map-addon-group/pushValue", value);
    }

    static removeMapAddonGroup(value) {
        return Store.dispatch("redactor-store-map-addon-group/removeValue", value);
    }

    static removeBulkMapAddonGroups(values) {
        return Store.dispatch("redactor-store-map-addon-group/removeBulkValues", values);
    }

    static convertMapAddonGroup(value) {
        return Store.dispatch("redactor-store-map-addon-group/convertToGlobal", value);
    }
}

